import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME } from "@dineout-cart-client/constants/Screen";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS } from "@dineout-cart-client/analytics/constants/Action";

export const clickMoreDetailsEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    couponCode: string,
    couponType: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_MORE_DETAILS,
        context: couponType,
        label: couponCode,
    });
};

export const clickCouponOffersEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    couponCode: string,
    contextVal: { storeId: string; offerId: string; isApplicable: string },
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.APPLY_COUPON,
        context: JSON.stringify(contextVal),
        label: couponCode,
    });
};

export const impressionCouponOffersEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    payload: { offerId: string; isApplicable: boolean; couponCode: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_COUPON_OFFERS,
        context: JSON.stringify({ offerId: payload.offerId, isApplicable: payload.isApplicable }),
        value: payload.couponCode,
    });
};

export const impressionRewardOffersEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    offerName: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_REWARD_OFFERS,
        value: offerName,
    });
};

export const impressionOffersEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_OFFERS,
    });
};

export const impressionPaymentBannerEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    bannerText: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_BANNER,
        value: bannerText,
    });
};

export const impressionRemoveCoupon = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_REMOVE_COUPON,
        extraParams: JSON.stringify({ cartId }),
    });
};

export const clickRemoveCoupon = (clickEvent: AnalyticsContextValue["clickEvent"], cartId: string): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_REMOVE_COUPON,
        extraParams: JSON.stringify({ cartId }),
    });
};
